
// Namespacing

window.site = (window.site || {});

// VideoBackground - opened / close

site.VideoBackground = (function VideoBackground($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function() {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Initiate VideoBackground
    initVideo();

    return true;

  };

    // ------------------------------------
    // INIT
    // ------------------------------------

    var initVideo = function() {

      $('#bg-video').vide({
        mp4: '/assets/videos/home',
        webm: '/assets/videos/home',
        ogv: '/assets/videos/home',
        poster: '/assets/videos/home'
      }, {
        loop: true,
        autoplay: true,
        position: '50% 50%',
        posterType: 'jpg',
        resizing: true,
        bgColor: '#000'
      });

    };

    return {
      init: init
    };


}.bind(site, jQuery)());